import React, { useEffect } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Paper from '@material-ui/core/Paper'
import { Typography } from '@material-ui/core'
import LinearProgress from '@material-ui/core/LinearProgress'

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  icon: {
    borderRadius: '50%',
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5'
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)'
    }
  },
  checkedIcon: {
    backgroundColor: '#4212E3',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""'
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3'
    }
  },
  answerPaper: {
    padding: '16px',
    margin: '16px 0',
    cursor: 'pointer',
  },
  isWrong: {
    padding: '16px',
    margin: '16px 0',
    cursor: 'pointer',
    borderColor: '#FD1E23'
  },
  isCorrect: {
    padding: '16px',
    margin: '16px 0',
    cursor: 'pointer',
    borderColor: 'green'
  },
  radioAnswer: {
    width: '100%'
  },
  formLabel: {
    color: '#4e4d4d'
  },
  errorMessage: {
    color: '#FD1E23',
    fontWeight: 'bold',
    paddingLeft: 25
  },
  correctMessage: {
    color: 'green',
    fontWeight: 'bold',
    paddingLeft: 25
  }
})

const StyledRadio = props => {
  const classes = useStyles()

  useEffect(() => {
    window.MathJax.typeset()
  })

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  )
}

const ExamAnswers = ({ answersContent, value, onChange, selectedAnswer, questionNumber, questionLoading, examType, quizType, answerFeedback, showAnswers }) => {
  const classes = useStyles()
  
  if (questionLoading) return <LinearProgress />

  return (
    <FormControl component="fieldset">
      <Typography gutterBottom variant="body2" component="p" className={classes.description} />
      {!(answersContent || {}).questao_anulada ? (
        <RadioGroup value={(value || (selectedAnswer && selectedAnswer[questionNumber]))} onChange={(e) => onChange(e.target.value)} aria-label="Respostas" name="customized-radios">
          {((answersContent || []).respostas || []).map((option, key) => {

            if (!showAnswers) {
              
              const isSelected = (answerFeedback?.selectedAnswer === option._id)
              const isCorrected = answerFeedback?.certa
              const selectedDesc = answerFeedback?.comentario
  
              const answerPaperClass = () => {
                if (isSelected) {
                  if (isCorrected === true) {
                    return classes.isCorrect
                  } else if (isCorrected === false) {
                    return classes.isWrong
                  } else {
                    return classes.answerPaper
                  }
                } else {
                  return classes.answerPaper
                }
              }
  
              return (
                <Paper elevation={0} variant="outlined" className={answerPaperClass()} component={'label'} htmlFor={option._id} key={option._id}>
                  <FormControlLabel
                    value={option._id}
                    control={<StyledRadio id={option._id} />}
                    label={<div dangerouslySetInnerHTML={{ __html: examType !== 'ProvaPersonalizada' && !quizType ? `${(option || {}).numero} - ${((option || {}).resposta || '').replace(/<math>|<\/math>/gi, '`')}` : `${((option || {}).resposta || '').replace(/<math>|<\/math>/gi, '`')}` }} />}
                    className={classes.radioAnswer}
                  />
                  {(isCorrected === false && isSelected) ? (
                    <Typography className={classes.errorMessage}>
                      <div dangerouslySetInnerHTML={{
                        __html: `${(selectedDesc || '').replace(/<math>|<\/math>/gi, '`')}`
                      }} />
                    </Typography>
                  ) : false}
                  {(isCorrected === true && isSelected) ? (
                    <Typography className={classes.correctMessage}>
                      <div dangerouslySetInnerHTML={{
                        __html: `${(selectedDesc || '').replace(/<math>|<\/math>/gi, '`')}`
                      }} />
                    </Typography>
                  ) : false} 
                </Paper>
              )
            } else {
              const currentAnswer = showAnswers?.todasRespostasPergunta[key]
              const currentId = currentAnswer?._id
              const isCorrect = currentAnswer?.certa
              const currentComment = currentAnswer?.comentario

              if (option._id !== currentId) return false

              const answerPaperClass = () => {
                if (isCorrect === true) {
                  return classes.isCorrect
                } else {
                  return classes.isWrong
                }
              }

              return (
                <Paper elevation={0} variant="outlined" className={answerPaperClass()} component={'label'} htmlFor={option._id} key={option._id}>
                  <FormControlLabel
                    disabled={true}
                    value={option._id}
                    control={<StyledRadio id={option._id} />}
                    label={<div dangerouslySetInnerHTML={{ __html: examType !== 'ProvaPersonalizada' && !quizType ? `${(option || {}).numero} - ${((option || {}).resposta || '').replace(/<math>|<\/math>/gi, '`')}` : `${((option || {}).resposta || '').replace(/<math>|<\/math>/gi, '`')}` }} />}
                    className={classes.radioAnswer}
                  />
                  {(isCorrect === false) ? (
                    <Typography className={classes.errorMessage}>
                      <div dangerouslySetInnerHTML={{
                          __html: `${(currentComment || '').replace(/<math>|<\/math>/gi, '`')}`
                      }} />
                    </Typography>
                  ) : false}
                  {(isCorrect === true) ? (
                    <Typography className={classes.correctMessage}>
                      <div dangerouslySetInnerHTML={{
                          __html: `${(currentComment || '').replace(/<math>|<\/math>/gi, '`')}`
                      }} />
                    </Typography>
                  ) : false} 
                </Paper>
              )
            }})}
        </RadioGroup>
      ) : (
          ((answersContent || []).respostas || []).map((option, key) => (
            <Paper elevation={0} variant="outlined" className={classes.answerPaper} component={'label'} htmlFor={option._id} key={option._id}>
              <Typography dangerouslySetInnerHTML={{ __html: examType !== 'ProvaPersonalizada' && !quizType ? `${(option || {}).numero} - ${((option || {}).resposta || '').replace(/<math>|<\/math>/gi, '`')}` : `${((option || {}).resposta || '').replace(/<math>|<\/math>/gi, '`')}` }} ></Typography>
            </Paper>
          ))
        )}
    </FormControl>
  )
}
export default ExamAnswers
